import type { ComponentProps } from "react";

export default function ConsultantIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99742 8.20126C9.88591 8.20126 10.6062 7.481 10.6062 6.59251C10.6062 5.70403 9.88591 4.98376 8.99742 4.98376C8.10893 4.98376 7.38867 5.70403 7.38867 6.59251C7.38867 7.481 8.10893 8.20126 8.99742 8.20126Z"
        fill={props.fill || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5494 2.31188C13.6907 2.31229 12.8456 2.09763 12.0913 1.6875L8.9975 0L5.90375 1.6875C5.14937 2.09763 4.30428 2.31229 3.44563 2.31188H1.15625V9.45C1.15672 10.9264 1.581 12.3717 2.37869 13.6141C3.17638 14.8565 4.31395 15.8438 5.65625 16.4587L8.9975 18L12.3444 16.4644C13.6867 15.8495 14.8242 14.8622 15.6219 13.6197C16.4196 12.3773 16.8439 10.9321 16.8444 9.45562V2.31188H14.5494ZM8.9975 3.69562C9.56934 3.69562 10.1283 3.86519 10.6038 4.18289C11.0793 4.50058 11.4498 4.95213 11.6687 5.48044C11.8875 6.00875 11.9448 6.59008 11.8332 7.15093C11.7216 7.71178 11.4463 8.22695 11.0419 8.6313C10.6376 9.03565 10.1224 9.31101 9.56155 9.42257C9.00071 9.53413 8.41937 9.47687 7.89107 9.25804C7.36276 9.03921 6.91121 8.66863 6.59351 8.19317C6.27582 7.7177 6.10625 7.15871 6.10625 6.58687C6.10774 5.82052 6.41283 5.08599 6.95472 4.54409C7.49661 4.0022 8.23115 3.69711 8.9975 3.69562ZM11.5681 13.0162C11.5681 12.6746 11.4324 12.347 11.1908 12.1054C10.9493 11.8638 10.6216 11.7281 10.28 11.7281H7.70937C7.54095 11.7281 7.37418 11.7613 7.21858 11.8257C7.06298 11.8902 6.9216 11.9847 6.80251 12.1038C6.68342 12.2229 6.58895 12.3642 6.5245 12.5198C6.46005 12.6754 6.42688 12.8422 6.42688 13.0106H5.13875C5.13875 12.3289 5.40958 11.675 5.89167 11.1929C6.37375 10.7108 7.0276 10.44 7.70937 10.44H10.28C10.9613 10.4415 11.6143 10.7128 12.0961 11.1946C12.5778 11.6763 12.8491 12.3293 12.8506 13.0106L11.5681 13.0162Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
}
